// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/mode/scholrship.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scholarship Page Styles (fixed alignment) */

:root {
  --brand: #400C4D;
  --bg: #ece4ed;
  --card: #d6c3d9;
  --text: #400C4D;
}

.scholarship-page {
  --sc-type-heading: clamp(2rem, 2.8vw, 2.9rem);
  --sc-type-subheading: 1.5rem;
  --sc-type-card-heading: 1.3rem;
  --sc-type-body: 1.05rem;
  --sc-type-label: 0.85rem;
  --sc-type-cta: 1rem;
  background: var(--bg);
  min-height: 100vh;
  color: var(--text);
  font-family: 'Inter', system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
  display: flex;
  flex-direction: column;
}

/* ------------------------------
   Hero
--------------------------------*/

.scholarship-hero {
  padding: 3rem 1.25rem 0.75rem;
}

.hero-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.scholarship-hero h1 {
  margin: 0;
  font-size: var(--sc-type-heading);
  letter-spacing: -0.02em;
}

.scholarship-hero p {
  margin: 0.6rem 0 0;
  color: rgba(64, 12, 77, 0.78);
  max-width: 920px;
  line-height: 1.65;
  font-size: var(--sc-type-body);
}

/* ------------------------------
   Main container
--------------------------------*/

.scholarship-content {
  width: min(1200px, calc(100% - 2.5rem));
  margin: 0 auto 3.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

/* ------------------------------
   Policy card (centered)
--------------------------------*/

.policy-card {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  background: var(--card);
  border: 2px solid var(--brand);
  border-radius: 14px;
  padding: 1.1rem 1.2rem;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
}

.policy-card h3 {
  margin: 0;
  font-size: var(--sc-type-card-heading);
}

.policy-card p {
  margin: 0.35rem 0 0;
  color: rgba(0, 0, 0, 0.7);
  line-height: 1.55;
  font-size: var(--sc-type-body);
}

.policy-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(64, 12, 77, 0.18);
  flex-shrink: 0;
}

.policy-icon .material-symbols-outlined {
  font-size: 22px;
  color: var(--brand);
}

/* ------------------------------
   SCAT card + avatar
--------------------------------*/

.sat-card-wrap {
  position: relative;
  width: 100%;
  padding-left: clamp(0px, 10vw, 180px); /* space for left avatar */
}

/* Avatar image (left overlapping) */
.sat-card__image {
  position: absolute;
  left: 0;
  top: 40px;
  width: clamp(160px, 22vw, 260px);
  height: auto;
  border-radius: 18px;
  z-index: 2;
}

.sat-card__image {
  transform: translateX(47px) translateY(10px);
}

/* Desktop: move the SCAT card slightly left */
@media (min-width: 861px) {
  .sat-card-wrap {
    transform: none;
  }
}

/* Mobile: do NOT shift it */
@media (max-width: 860px) {
  .sat-card-wrap {
    transform: none;
  }
}


.sat-card__image img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

/* Main SCAT card */
.sat-card {
  width: 100%;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  border-radius: 24px;
  overflow: hidden;
  border: 2px solid var(--brand);
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.12);
  background: transparent;
}

.sat-copy {
  background: var(--card);
  padding: clamp(1.5rem, 2.6vw, 2.5rem);
  display: flex;
  flex-direction: column;
  gap: 0.95rem;
}

.pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 0.4rem 0.75rem;
  border-radius: 999px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  font-size: var(--sc-type-label);
  font-weight: 700;
  color: rgba(64, 12, 77, 0.9);
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(64, 12, 77, 0.2);
}

.sat-copy h2 {
  margin: 0;
  font-size: var(--sc-type-subheading);
  letter-spacing: -0.01em;
  color: var(--brand);
}

.sat-copy p {
  margin: 0;
  color: rgba(0, 0, 0, 0.72);
  line-height: 1.65;
  font-size: var(--sc-type-body);
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

/* Mobile-only SCAT card image override */
@media (max-width: 860px) {
  .sat-card__image img {
    display: none;
  }

  .sat-card__image {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.stat-grid .label {
  font-size: var(--sc-type-label);
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(64, 12, 77, 0.45);
  margin: 0;
}

.stat-grid .value {
  margin: 0.25rem 0 0;
  font-weight: 800;
  color: #0f172a;
}

.btn {
  border-radius: 999px;
  padding: 0.9rem 1.6rem;
  font-weight: 650;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  user-select: none;
  font-size: var(--sc-type-cta);
}

.btn:hover {
  transform: translateY(-1px);
  color: #f59e0b;
  filter: brightness(1.02);
}

.sat-btn {
  margin-top: 0.25rem;
  background: var(--brand);
  color: white;
  box-shadow: 0 16px 30px rgba(64, 12, 77, 0.22);
}

.sat-highlight {
  background: var(--brand);
  color: white;
  padding: clamp(1.6rem, 2.5vw, 2.5rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.6rem;
  border-left: 2px solid rgba(255, 255, 255, 0.08);
}

.sat-highlight .badge {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #fbbf24;
  display: grid;
  place-items: center;
  margin-bottom: 0.35rem;
  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.25);
}

.sat-highlight .badge .material-symbols-outlined {
  color: #ffffff;
}

.sat-highlight .highlight-label {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  font-size: var(--sc-type-label);
  color: rgba(255, 255, 255, 0.7);
}

.sat-highlight h3 {
  font-size: clamp(3rem, 4.4vw, 4.6rem);
  margin: 0.1rem 0 0;
  line-height: 1;
  color: #fbbf24;
}

.sat-highlight .subtext {
  margin: 0;
  font-size: var(--sc-type-body);
  color: rgba(255, 255, 255, 0.78);
}

.sat-highlight .divider {
  width: 74px;
  height: 5px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.65);
  margin: 0.65rem auto 0.4rem;
}

.sat-highlight .footnote {
  font-size: 0.88rem;
  color: rgba(255, 255, 255, 0.7);
  margin: 0.35rem 0 0;
}

/* ------------------------------
   Tables grid
--------------------------------*/

.tables-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
}

.table-card {
  background: var(--card);
  border-radius: 1.5rem;
  padding: 2rem;
  box-shadow: 0 25px 45px rgba(15, 23, 42, 0.08);
  border: 2px solid var(--brand);
}

.table-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
  color: var(--brand);
}

.table-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: #F6EEF8;
  display: grid;
  place-items: center;
  color: var(--brand);
}

.table-icon.orange {
  background: #fef3c7;
  color: #f97316;
}

.table-card h3 {
  margin: 0;
  font-size: var(--sc-type-subheading);
}

.table {
  margin-top: 0.5rem;
  border: 1px solid rgba(64, 12, 77, 0.18);
  border-radius: 1rem;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.2);
}

.table-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.85rem 1.25rem;
  gap: 1rem;
}

.table-row span:first-child {
  flex: 1;
  min-width: 0;
}

.table-row span:last-child {
  flex-shrink: 0;
}

.table-row.table-head {
  background: rgba(255, 255, 255, 0.75);
  font-size: var(--sc-type-label);
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: rgba(64, 12, 77, 0.55);
}

.table-row + .table-row {
  border-top: 1px solid rgba(64, 12, 77, 0.12);
}

.table-row:hover {
  background: rgba(255, 255, 255, 0.6);
}

.bold {
  font-weight: 800;
  color: #16a34a;
}

/* ------------------------------
   Terms
--------------------------------*/

.terms-card {
  background: var(--card);
  border-radius: 1.25rem;
  padding: 2rem;
  border: 2px solid var(--brand);
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);
}

.terms-head {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1rem;
}

.terms-head .material-symbols-outlined {
  color: var(--brand);
}

.terms-head h4 {
  margin: 0;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.3em;
  color: #000;
}

.terms-card ul {
  margin: 0;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  color: var(--brand);
}

.terms-card li {
  list-style: none;
  padding-left: 1.25rem;
  position: relative;
  color: var(--brand);
  line-height: 1.65;
  font-size: var(--sc-type-body);
}

.terms-card li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.72rem;
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--brand);
}

/* ------------------------------
   CTA + Footer
--------------------------------*/

.cta-section {
  background: var(--brand);
  border-radius: 1.5rem;
  padding: 2rem;
  color: white;
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) auto;
  align-items: center;
  gap: 2rem;
  box-shadow: 0 30px 60px rgba(64, 12, 77, 0.35);
}

.cta-copy {
  max-width: 620px;
}

.cta-section h2 {
  margin: 0;
  font-size: var(--sc-type-subheading);
}

.cta-section p {
  margin: 0.35rem 0 0;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.55;
  font-size: var(--sc-type-body);
}

.cta-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: stretch;
}

.btn.primary {
  background: #400C4D;
  color: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  padding: 0.9rem 1.25rem;
  min-height: 58px;
  width: max-content;
  border: 1px solid #d6c3d9;
}

.btn.alt {
  background: #400C4D;
  border: 1px solid rgba(255, 255, 255, 0.35);
  color: white;
  padding: 0.75rem 1.05rem;
  min-height: 58px;
  gap: 0.7rem;
  text-decoration: none;
}

.cta-phone {
  display: inline-flex;
  align-items: center;
}

.cta-phone__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;
}

.cta-phone__label {
  margin: 0;
  font-size: var(--sc-type-label);
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.75);
}

.cta-phone__number {
  font-size: 1.15rem;
  font-weight: 700;
  color: #fff;
}

.scholarship-footer {
  text-align: center;
  padding: 2rem 1rem;
  color: rgba(64, 12, 77, 0.55);
}

/* ------------------------------
   Responsive
--------------------------------*/

@media (max-width: 980px) {
  .tables-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 860px) {
  .scholarship-hero {
    padding: 2rem 1rem 0.5rem;
  }

  .scholarship-content {
    gap: 1.1rem;
  }

  .sat-card-wrap {
    padding-left: 0;
    padding-top: 0;
  }

  .sat-card__image {
    display: none;
  }

  .sat-card {
    grid-template-columns: 1fr;
  }

  .sat-highlight {
    border-left: none;
    border-top: 2px solid rgba(255, 255, 255, 0.08);
  }
}

@media (max-width: 520px) {
  .scholarship-content {
    width: calc(100% - 1.5rem);
  }

  .table-card {
    padding: 1.25rem;
  }

  .cta-section {
    padding: 1.5rem;
    grid-template-columns: 1fr;
    gap: 1.1rem;
  }

  .cta-actions {
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Scholarship/scholarship.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,mFAAmF;EACnF,aAAa;EACb,sBAAsB;AACxB;;AAEA;;iCAEiC;;AAEjC;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;;iCAEiC;;AAEjC;EACE,uCAAuC;EACvC,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;iCAEiC;;AAEjC;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;iCAEiC;;AAEjC;EACE,kBAAkB;EAClB,WAAW;EACX,qCAAqC,EAAE,0BAA0B;AACnE;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,8CAA8C;AAC9C;EACE;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,8CAA8C;EAC9C,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE;IACE,aAAa;EACf;;EAEA;IACE,yDAA+D;IAC/D,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,uEAAuE;EACvE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;iCAEiC;;AAEjC;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;iCAEiC;;AAEjC;EACE,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;;iCAEiC;;AAEjC;EACE,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;iCAEiC;;AAEjC;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,+CAA+C;EACjD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/* Scholarship Page Styles (fixed alignment) */\n\n:root {\n  --brand: #400C4D;\n  --bg: #ece4ed;\n  --card: #d6c3d9;\n  --text: #400C4D;\n}\n\n.scholarship-page {\n  --sc-type-heading: clamp(2rem, 2.8vw, 2.9rem);\n  --sc-type-subheading: 1.5rem;\n  --sc-type-card-heading: 1.3rem;\n  --sc-type-body: 1.05rem;\n  --sc-type-label: 0.85rem;\n  --sc-type-cta: 1rem;\n  background: var(--bg);\n  min-height: 100vh;\n  color: var(--text);\n  font-family: 'Inter', system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ------------------------------\n   Hero\n--------------------------------*/\n\n.scholarship-hero {\n  padding: 3rem 1.25rem 0.75rem;\n}\n\n.hero-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.scholarship-hero h1 {\n  margin: 0;\n  font-size: var(--sc-type-heading);\n  letter-spacing: -0.02em;\n}\n\n.scholarship-hero p {\n  margin: 0.6rem 0 0;\n  color: rgba(64, 12, 77, 0.78);\n  max-width: 920px;\n  line-height: 1.65;\n  font-size: var(--sc-type-body);\n}\n\n/* ------------------------------\n   Main container\n--------------------------------*/\n\n.scholarship-content {\n  width: min(1200px, calc(100% - 2.5rem));\n  margin: 0 auto 3.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n}\n\n/* ------------------------------\n   Policy card (centered)\n--------------------------------*/\n\n.policy-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.9rem;\n  background: var(--card);\n  border: 2px solid var(--brand);\n  border-radius: 14px;\n  padding: 1.1rem 1.2rem;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);\n}\n\n.policy-card h3 {\n  margin: 0;\n  font-size: var(--sc-type-card-heading);\n}\n\n.policy-card p {\n  margin: 0.35rem 0 0;\n  color: rgba(0, 0, 0, 0.7);\n  line-height: 1.55;\n  font-size: var(--sc-type-body);\n}\n\n.policy-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  background: rgba(255, 255, 255, 0.55);\n  border: 1px solid rgba(64, 12, 77, 0.18);\n  flex-shrink: 0;\n}\n\n.policy-icon .material-symbols-outlined {\n  font-size: 22px;\n  color: var(--brand);\n}\n\n/* ------------------------------\n   SCAT card + avatar\n--------------------------------*/\n\n.sat-card-wrap {\n  position: relative;\n  width: 100%;\n  padding-left: clamp(0px, 10vw, 180px); /* space for left avatar */\n}\n\n/* Avatar image (left overlapping) */\n.sat-card__image {\n  position: absolute;\n  left: 0;\n  top: 40px;\n  width: clamp(160px, 22vw, 260px);\n  height: auto;\n  border-radius: 18px;\n  z-index: 2;\n}\n\n.sat-card__image {\n  transform: translateX(47px) translateY(10px);\n}\n\n/* Desktop: move the SCAT card slightly left */\n@media (min-width: 861px) {\n  .sat-card-wrap {\n    transform: none;\n  }\n}\n\n/* Mobile: do NOT shift it */\n@media (max-width: 860px) {\n  .sat-card-wrap {\n    transform: none;\n  }\n}\n\n\n.sat-card__image img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n/* Main SCAT card */\n.sat-card {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1.1fr 0.9fr;\n  border-radius: 24px;\n  overflow: hidden;\n  border: 2px solid var(--brand);\n  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.12);\n  background: transparent;\n}\n\n.sat-copy {\n  background: var(--card);\n  padding: clamp(1.5rem, 2.6vw, 2.5rem);\n  display: flex;\n  flex-direction: column;\n  gap: 0.95rem;\n}\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  padding: 0.4rem 0.75rem;\n  border-radius: 999px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  font-size: var(--sc-type-label);\n  font-weight: 700;\n  color: rgba(64, 12, 77, 0.9);\n  background: rgba(255, 255, 255, 0.55);\n  border: 1px solid rgba(64, 12, 77, 0.2);\n}\n\n.sat-copy h2 {\n  margin: 0;\n  font-size: var(--sc-type-subheading);\n  letter-spacing: -0.01em;\n  color: var(--brand);\n}\n\n.sat-copy p {\n  margin: 0;\n  color: rgba(0, 0, 0, 0.72);\n  line-height: 1.65;\n  font-size: var(--sc-type-body);\n}\n\n.stat-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n/* Mobile-only SCAT card image override */\n@media (max-width: 860px) {\n  .sat-card__image img {\n    display: none;\n  }\n\n  .sat-card__image {\n    background-image: url(\"../../../../public/mode/scholrship.png\");\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n  }\n}\n\n.stat-grid .label {\n  font-size: var(--sc-type-label);\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: rgba(64, 12, 77, 0.45);\n  margin: 0;\n}\n\n.stat-grid .value {\n  margin: 0.25rem 0 0;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.btn {\n  border-radius: 999px;\n  padding: 0.9rem 1.6rem;\n  font-weight: 650;\n  border: none;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  user-select: none;\n  font-size: var(--sc-type-cta);\n}\n\n.btn:hover {\n  transform: translateY(-1px);\n  color: #f59e0b;\n  filter: brightness(1.02);\n}\n\n.sat-btn {\n  margin-top: 0.25rem;\n  background: var(--brand);\n  color: white;\n  box-shadow: 0 16px 30px rgba(64, 12, 77, 0.22);\n}\n\n.sat-highlight {\n  background: var(--brand);\n  color: white;\n  padding: clamp(1.6rem, 2.5vw, 2.5rem);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 0.6rem;\n  border-left: 2px solid rgba(255, 255, 255, 0.08);\n}\n\n.sat-highlight .badge {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: #fbbf24;\n  display: grid;\n  place-items: center;\n  margin-bottom: 0.35rem;\n  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.25);\n}\n\n.sat-highlight .badge .material-symbols-outlined {\n  color: #ffffff;\n}\n\n.sat-highlight .highlight-label {\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.22em;\n  font-size: var(--sc-type-label);\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.sat-highlight h3 {\n  font-size: clamp(3rem, 4.4vw, 4.6rem);\n  margin: 0.1rem 0 0;\n  line-height: 1;\n  color: #fbbf24;\n}\n\n.sat-highlight .subtext {\n  margin: 0;\n  font-size: var(--sc-type-body);\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.sat-highlight .divider {\n  width: 74px;\n  height: 5px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.65);\n  margin: 0.65rem auto 0.4rem;\n}\n\n.sat-highlight .footnote {\n  font-size: 0.88rem;\n  color: rgba(255, 255, 255, 0.7);\n  margin: 0.35rem 0 0;\n}\n\n/* ------------------------------\n   Tables grid\n--------------------------------*/\n\n.tables-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.5rem;\n}\n\n.table-card {\n  background: var(--card);\n  border-radius: 1.5rem;\n  padding: 2rem;\n  box-shadow: 0 25px 45px rgba(15, 23, 42, 0.08);\n  border: 2px solid var(--brand);\n}\n\n.table-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1.25rem;\n  color: var(--brand);\n}\n\n.table-icon {\n  width: 46px;\n  height: 46px;\n  border-radius: 12px;\n  background: #F6EEF8;\n  display: grid;\n  place-items: center;\n  color: var(--brand);\n}\n\n.table-icon.orange {\n  background: #fef3c7;\n  color: #f97316;\n}\n\n.table-card h3 {\n  margin: 0;\n  font-size: var(--sc-type-subheading);\n}\n\n.table {\n  margin-top: 0.5rem;\n  border: 1px solid rgba(64, 12, 77, 0.18);\n  border-radius: 1rem;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.table-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.85rem 1.25rem;\n  gap: 1rem;\n}\n\n.table-row span:first-child {\n  flex: 1;\n  min-width: 0;\n}\n\n.table-row span:last-child {\n  flex-shrink: 0;\n}\n\n.table-row.table-head {\n  background: rgba(255, 255, 255, 0.75);\n  font-size: var(--sc-type-label);\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: rgba(64, 12, 77, 0.55);\n}\n\n.table-row + .table-row {\n  border-top: 1px solid rgba(64, 12, 77, 0.12);\n}\n\n.table-row:hover {\n  background: rgba(255, 255, 255, 0.6);\n}\n\n.bold {\n  font-weight: 800;\n  color: #16a34a;\n}\n\n/* ------------------------------\n   Terms\n--------------------------------*/\n\n.terms-card {\n  background: var(--card);\n  border-radius: 1.25rem;\n  padding: 2rem;\n  border: 2px solid var(--brand);\n  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);\n}\n\n.terms-head {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  margin-bottom: 1rem;\n}\n\n.terms-head .material-symbols-outlined {\n  color: var(--brand);\n}\n\n.terms-head h4 {\n  margin: 0;\n  font-size: 1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.3em;\n  color: #000;\n}\n\n.terms-card ul {\n  margin: 0;\n  padding-left: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  color: var(--brand);\n}\n\n.terms-card li {\n  list-style: none;\n  padding-left: 1.25rem;\n  position: relative;\n  color: var(--brand);\n  line-height: 1.65;\n  font-size: var(--sc-type-body);\n}\n\n.terms-card li::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0.72rem;\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--brand);\n}\n\n/* ------------------------------\n   CTA + Footer\n--------------------------------*/\n\n.cta-section {\n  background: var(--brand);\n  border-radius: 1.5rem;\n  padding: 2rem;\n  color: white;\n  display: grid;\n  grid-template-columns: minmax(0, 1.2fr) auto;\n  align-items: center;\n  gap: 2rem;\n  box-shadow: 0 30px 60px rgba(64, 12, 77, 0.35);\n}\n\n.cta-copy {\n  max-width: 620px;\n}\n\n.cta-section h2 {\n  margin: 0;\n  font-size: var(--sc-type-subheading);\n}\n\n.cta-section p {\n  margin: 0.35rem 0 0;\n  color: rgba(255, 255, 255, 0.85);\n  line-height: 1.55;\n  font-size: var(--sc-type-body);\n}\n\n.cta-actions {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: stretch;\n}\n\n.btn.primary {\n  background: #400C4D;\n  color: white;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  padding: 0.9rem 1.25rem;\n  min-height: 58px;\n  width: max-content;\n  border: 1px solid #d6c3d9;\n}\n\n.btn.alt {\n  background: #400C4D;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  color: white;\n  padding: 0.75rem 1.05rem;\n  min-height: 58px;\n  gap: 0.7rem;\n  text-decoration: none;\n}\n\n.cta-phone {\n  display: inline-flex;\n  align-items: center;\n}\n\n.cta-phone__content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  line-height: 1.2;\n}\n\n.cta-phone__label {\n  margin: 0;\n  font-size: var(--sc-type-label);\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.cta-phone__number {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #fff;\n}\n\n.scholarship-footer {\n  text-align: center;\n  padding: 2rem 1rem;\n  color: rgba(64, 12, 77, 0.55);\n}\n\n/* ------------------------------\n   Responsive\n--------------------------------*/\n\n@media (max-width: 980px) {\n  .tables-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 860px) {\n  .scholarship-hero {\n    padding: 2rem 1rem 0.5rem;\n  }\n\n  .scholarship-content {\n    gap: 1.1rem;\n  }\n\n  .sat-card-wrap {\n    padding-left: 0;\n    padding-top: 0;\n  }\n\n  .sat-card__image {\n    display: none;\n  }\n\n  .sat-card {\n    grid-template-columns: 1fr;\n  }\n\n  .sat-highlight {\n    border-left: none;\n    border-top: 2px solid rgba(255, 255, 255, 0.08);\n  }\n}\n\n@media (max-width: 520px) {\n  .scholarship-content {\n    width: calc(100% - 1.5rem);\n  }\n\n  .table-card {\n    padding: 1.25rem;\n  }\n\n  .cta-section {\n    padding: 1.5rem;\n    grid-template-columns: 1fr;\n    gap: 1.1rem;\n  }\n\n  .cta-actions {\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
